import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { User, TtNumberStake } from "@/CodegenTypes";
import { formatDollar } from "@/helpers/formatDollar";
import { sumBy } from "lodash";
import { customMoment } from "@/main";
import { queries } from "@/apollo";


export default /*#__PURE__*/_defineComponent({
  __name: 'TTNumberStakeModal',
  props: {
    value: { type: Boolean },
    startReleaseDate: null,
    userId: null,
    number: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", val: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  startReleaseDate: Date;
  userId: User["userId"];
  number: string;
};





const queryVariables = computed(() => ({
  releaseDate: customMoment(props.startReleaseDate)
    .startOf("day")
    .toDate(),
  appMode: "DD",
  behalfOf: props.userId,
  number: props.number
}));

const { result, loading: apolloLoading } = useQuery<{
  ttNumberStakes: TtNumberStake[];
}>(
  queries.ttNumberStakes,
  queryVariables,
  {
    enabled: computed(() => !!props.startReleaseDate && !!props.number && !!props.userId),
    fetchPolicy: "cache-and-network",
  }
);

const ttNumberStakes = computed(() => result.value?.ttNumberStakes ?? null);

const summary = computed(() => {
  if (!ttNumberStakes.value) {
    return null;
  }
  return {
    numberCount: ttNumberStakes.value.length,
    in: {
      amount: sumBy(ttNumberStakes.value, (stake) => stake.in)
    },
    intake: {
      amount: sumBy(ttNumberStakes.value, (stake) => stake.intake)
    },
    toCompany: {
      amount: sumBy(ttNumberStakes.value, (stake) => stake.toCompany)
    }
  };
});

function toggleModal(val: boolean) {
  emit("input", val);
}

return { __sfc: true,props, emit, queryVariables, result, apolloLoading, ttNumberStakes, summary, toggleModal, formatDollar }
}

})